export default {
  "title": "Code Genius : Gallery",
  "header" : "Gallery",
  "gallery": "Gallery",
  "button": {
    "viewByCourse": "View by Courses",
    "viewAll": "View All"
  }
}